import {initReactI18next} from 'react-i18next';
import i18n from 'i18next';
import resources from 'locale/generated';
import getPreferredLanguage from 'utils/locale';

export const initializeI18n = () =>
    i18n.use(initReactI18next).init({
        fallbackLng: 'en',
        fallbackNS: ['common', 'form'],
        interpolation: {
            escapeValue: false,
        },
        lng: getPreferredLanguage(),
        resources,
        returnNull: false,
        supportedLngs: ['en', 'ja'],
    });

initializeI18n();
export default i18n;
